module.exports = __webpack_public_path__ + "img/pen.08dee293.svg";